import React from 'react';
import cn from 'classnames';
import Section from 'components/Section';
import SearchForm from 'containers/SearchForm.container';

export default ({ pic, title }) => (
  <Section name="hero" isFull={true} style={{ backgroundImage: `url(${pic})` }} className={cn('hero-section', 'd-flex', 'justify-content-center', 'align-items-center', 'flex-column')}>
    <div className="container" style={{zIndex:1}}>
      <div className="col-md-8 offset-md-2">
        <h1 className="text-uppercase text-center">{title}</h1>
      </div>
      <SearchForm />
    </div>
  </Section>
);


// WEBPACK FOOTER //
// ./src/components/Hero.js